import { wefloLocalStorage } from '@/configs';
import { authorization } from '@/constants';
import { SignInCredentialsDTO } from '../types';

export function useAuthInfo() {
  const authInfo: SignInCredentialsDTO = JSON.parse(wefloLocalStorage.getItem(authorization));

  return { authInfo };
}
